import { html, unsafeCSS } from 'lit';
import { property, state } from 'lit/decorators.js';
import { ScopedRegistryHost } from '@lit-labs/scoped-registry-mixin';
import { LeafElement } from '@cigna/dcws_leaf-web-components/components/leaf-element.js';
import styles from './plan-finder-id-card.scss?inline';

export class CHCPlanFinderIdCard extends ScopedRegistryHost(LeafElement) {
  static override styles = unsafeCSS(styles);

  @property({ reflect: true, type: Array })
  imgSources!: [];

  @property({ reflect: true, type: Array })
  imgAlts!: [];

  @property({ reflect: true, type: Array })
  imgLinkTexts!: [];

  @state()
  activeIndex = 0;

  toggleCards(event: FocusEvent) {
    event.preventDefault();
    const { currentTarget } = event;
    const activeIndex = (currentTarget as HTMLElement).dataset?.index;
    this.activeIndex = parseInt(activeIndex || '', 10);
  }

  renderLinks(text: string, index: number) {
    if (this.activeIndex === index) {
      return html`<span>${text}</span>`;
    } else {
      return html` <span>
        <a href="#" @click="${this.toggleCards}" data-index=${index}> ${text} </a>
      </span>`;
    }
  }

  override render() {
    return html`
      <div class="chcapp-plan-finder-id-card">
        ${this.imgSources.map(
          (imageSrc: string, index: number) => html`
            <picture class="${this.activeIndex === index ? 'show' : ''}">
              <img alt="${this.imgAlts[index]}" loading="eager" src="${imageSrc}" />
            </picture>
          `,
        )}
        <div class="chcapp-plan-finder-id-card__links">
          ${this.imgLinkTexts.map((text: string, index: number) => html`${this.renderLinks(text, index)}`)}
        </div>
      </div>
      <slot name="content"></slot>
    `;
  }
}
